import request from '@/utils/request3'
import store from '@/store'
import qs from 'qs'
const serviceName = store.state.serviceName.workOrder

// 借款申请单提交
export function loanSubmit(data) {
    return request({
        url: serviceName + `/finance/loan_submit`,
        method: 'post',
        data: data
    })
}

// 借款申请列表清单
export function getLoanApplyList(data) {
    return request({
        method: 'post',
        url: serviceName + `/finance/loan_apply_list`,
        data: qs.stringify(data)
    })
}

// 借款申请单详情
export function getLoanApplyDetail(data) {
    return request({
        method: 'get',
        url: serviceName + `/finance/query_loan_apply?id=${data.id}`,
    })
}

// 借款审批记录(待审批和已审批)
export function getLoanApprovalList(data) {
    return request({
        method: 'post',
        url: serviceName + `/finance/loan_approved_list`,
        data: qs.stringify(data)
    })
}

// 借款审批
export function loanApproval(data) {
    return request({
        method: 'post',
        url: serviceName + `/finance/loan_approve_reject`,
        data: data
    })
}

// 借款审批记录
export function getApprovalStageList(data) {
    return request({
        method: 'get',
        url: serviceName + `/finance/approval_stage_list?applyCode=${data.applyCode}`,
    })
}

// 借款撤销
export function loanCancel(data) {
    return request({
        method: 'post',
        url: serviceName + `/finance/loan_cancel?id=${data.id}`,
    })
}

// 付款以及还款确认
export function payReturnSubmit(data) {
    return request({
        method: 'post',
        url: serviceName + `/finance/pay_return_submit`,
        data: data
    })
}